import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// import logologin from '../../Comman/images/logo-new.png'
import logologin from '../../Comman/images/alecom.png'
import NotificationContainer from '../containers/notificationContainer';
import Auth from '../../auth';
import i18n from '../../i18n';
import EngIcon from '../../Comman/images/England.png';
import SwedishIcon from '../../Comman/images/Sweden.png';
import { withNamespaces } from 'react-i18next';

class SuperAdminHeaderComponent extends Component {
    constructor(props) {

        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
        Auth.signout();
        this.props.logout();
    }
    changeLang(lng){
        i18n.changeLanguage(lng);
        sessionStorage.setItem('Language',lng)
        var lang;
        if(lng == "en"){
          lang = "English";
        }
        else{
          lang = "Swedish";
        }
        this.props.setLanguage(lang);                   
    }
    render() {
        const { t } = this.props;
        return (
            <div>
                <nav className="user-menu">
                <a href="#" className="main-menu-access">
                    <i className="icon-proton-logo"></i>
                    <i className="icon-reorder"></i>
                </a>
            </nav>
            <section className="title-bar heaadd" style={{zIndex:'99'}}>
                <div className="logo">
                    <Link to="/superadmin/dashboard">
                        <img  src={logologin} alt="" className="imgWidthSet" />
                    </Link>
                </div>
                <div className="header-right">
                    <div className="profile_details_left">
                        <div className="header-right-left">
                    
                            <NotificationContainer />
                            
                        </div>
                        <div className="profile_details">
                            <ul>
                                <li className="dropdown profile_details_drop">
                                    <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                        <div className="profile_img">
                                            <span className="prfil-img"><i className="fa fa-user" aria-hidden="true"></i></span>
                                            <div className="clearfix"></div>
                                        </div>
                                    </a>
                                    <ul className="dropdown-menu drp-mnu">
                                        
                                        <li> 
                                            {/*<Link className="nav-link" to="/Admin/Profile"> 
                                                <i className="fa fa-user"></i>Profile
                                            </Link>*/}
                                        </li>
                                        <li> <a href="#" onClick={this.logout}><i className="fa fa-sign-out"></i> {t('Menu.Logout')}</a> </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                      
                       
                            <span onClick={() =>{this.changeLang('sv')}} className="top_flag">
                                <img className="flag-icon" src={SwedishIcon} alt="" title="Swedish" />
                            </span>
                            <span onClick={() =>{this.changeLang('en')}} className="top_flg">
                                <img className="flag-icon" src={EngIcon} alt="" title="English" />
                            </span>
                        
                    </div>
                </div>
                <div className="clearfix"> </div>
            </section>
            </div>
        );
    }
}

export default withNamespaces()(SuperAdminHeaderComponent);